module.exports = __webpack_public_path__ + "static/media/arrows-from-center.a333c5c4.svg";